var map = {
	"./": "WuU6",
	"./angle-right": "qDzp",
	"./angle-right.js": "qDzp",
	"./bars": "8q1j",
	"./bars.js": "8q1j",
	"./book": "Pv//",
	"./book.js": "Pv//",
	"./card": "ihWT",
	"./card.js": "ihWT",
	"./caret-right": "s6nn",
	"./caret-right.js": "s6nn",
	"./caret-up": "QedG",
	"./caret-up.js": "QedG",
	"./checkCircle": "Y07F",
	"./checkCircle.js": "Y07F",
	"./chevron-left": "qE2z",
	"./chevron-left.js": "qE2z",
	"./chevron-right": "FUf8",
	"./chevron-right.js": "FUf8",
	"./chevrondown": "tw/y",
	"./chevrondown.js": "tw/y",
	"./chevronup": "rezj",
	"./chevronup.js": "rezj",
	"./clock": "Elup",
	"./clock.js": "Elup",
	"./close": "NDRu",
	"./close.js": "NDRu",
	"./emoji": "RMfq",
	"./emoji.js": "RMfq",
	"./envelope": "H5oK",
	"./envelope-round": "4PsW",
	"./envelope-round.js": "4PsW",
	"./envelope.js": "H5oK",
	"./facebook": "ZQ44",
	"./facebook-round": "FfNV",
	"./facebook-round.js": "FfNV",
	"./facebook-white-round": "/NCp",
	"./facebook-white-round.js": "/NCp",
	"./facebook.js": "ZQ44",
	"./google": "U437",
	"./google.js": "U437",
	"./home": "j9j8",
	"./home.js": "j9j8",
	"./icon": "wyau",
	"./icon.js": "wyau",
	"./index": "WuU6",
	"./index.js": "WuU6",
	"./instagram": "HoTO",
	"./instagram-round": "83yY",
	"./instagram-round.js": "83yY",
	"./instagram.js": "HoTO",
	"./linkedin": "4jXb",
	"./linkedin.js": "4jXb",
	"./mail": "48xe",
	"./mail-round": "ypBb",
	"./mail-round-2": "9MWr",
	"./mail-round-2.js": "9MWr",
	"./mail-round.js": "ypBb",
	"./mail.js": "48xe",
	"./map-marker": "ydVz",
	"./map-marker.js": "ydVz",
	"./menu": "mfc5",
	"./menu.js": "mfc5",
	"./phone": "W/8O",
	"./phone.js": "W/8O",
	"./pinterest-round": "4Ik8",
	"./pinterest-round-footer": "V0+S",
	"./pinterest-round-footer.js": "V0+S",
	"./pinterest-round.js": "4Ik8",
	"./play": "3DAS",
	"./play.js": "3DAS",
	"./quote": "0mnw",
	"./quote.js": "0mnw",
	"./readmorearrow": "cGSY",
	"./readmorearrow.js": "cGSY",
	"./shopping-bag": "Byyh",
	"./shopping-bag.js": "Byyh",
	"./slider_arrow": "d6Vz",
	"./slider_arrow.js": "d6Vz",
	"./star": "qcSq",
	"./star.js": "qcSq",
	"./sync": "XgUq",
	"./sync.js": "XgUq",
	"./tag": "NpF3",
	"./tag.js": "NpF3",
	"./thumbs-up": "c1b+",
	"./thumbs-up.js": "c1b+",
	"./times-circle": "eYm8",
	"./times-circle.js": "eYm8",
	"./truck": "88eM",
	"./truck.js": "88eM",
	"./twitter": "DjAn",
	"./twitter.js": "DjAn",
	"./youtube": "8rIq",
	"./youtube-round": "bs97",
	"./youtube-round.js": "bs97",
	"./youtube-white-round": "sMcx",
	"./youtube-white-round.js": "sMcx",
	"./youtube.js": "8rIq"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "o/QR";